/**
 * Validates if a string is a valid MongoDB ObjectId
 * @param id - The string to validate
 * @returns boolean - True if the string is a valid MongoDB ObjectId (24 hexadecimal characters)
 */
export const isValidObjectId = (id: string): boolean => {
  return Boolean(id && /^[0-9a-fA-F]{24}$/.test(id));
}; 